import { useState } from "react";
import classNames from "classnames/dedupe";
import {
  Button,
  Icon,
  type IconDefinition,
  type ButtonProps,
} from "@simplybusiness/mobius";
import { loading } from "@simplybusiness/icons";
import { useTokensValues } from "../../../hooks/tokens";
import type { Action } from "../../../pages";

export type HiddenInput = {
  name: string;
  value: string;
};

export interface ShowcaseFormProps {
  action: Action;
  buttonVariant?: ButtonProps["variant"];
  buttonClassName?: string;
  className?: string;
  icon?: IconDefinition;
  loadingIcon?: IconDefinition;
  hiddenInputs?: HiddenInput[];
}

export const ShowcaseForm = ({
  action,
  buttonVariant = "primary",
  buttonClassName,
  className,
  icon,
  loadingIcon = loading,
  hiddenInputs = [],
}: ShowcaseFormProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { authenticityToken, journeyToken } = useTokensValues();

  const formClassName = classNames("mobius-showcase-form", className);

  return (
    <form
      className={formClassName}
      action={action.url}
      method={action.method}
      onSubmit={() => setIsLoading(true)}
      aria-label={action.label}
      name={action.name}
      acceptCharset="UTF-8"
    >
      <input
        type="hidden"
        name="authenticity_token"
        value={authenticityToken}
      />
      <input type="hidden" name="journey_token" value={journeyToken} />
      {hiddenInputs.map(input => (
        <input
          key={input.name}
          type="hidden"
          name={input.name}
          value={input.value}
        />
      ))}
      <div className="mobius-showcase-form__submit">
        <Button
          type="submit"
          variant={buttonVariant}
          className={buttonClassName}
          isDisabled={isLoading}
        >
          {action.label}{" "}
          {isLoading ? (
            <Icon
              icon={loadingIcon}
              spin
              fixedWidth
              title="Processing your request"
            />
          ) : (
            icon && <Icon icon={icon} fixedWidth title="Submit form" />
          )}
        </Button>
      </div>
    </form>
  );
};
